<template>
<div class="chapter">
<div class="inner_page">
<p class="block_11">
</p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_13"><span class="text_4">“</span><span class="text_5">When the truths of the world become all too real, I pray the elusiveness of things unknown lift you far and away from here.”</span></p>
<p class="block_14"> </p>
<p class="block_15">—S.M. Atlas</p>
<p class="block_16" id="calibre_pb_3"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?0460afd6